import React from 'react';
import { Camera, Calendar, User, Clock } from 'lucide-react';

export const RecentActivity = ({ activities }) => {
  const getActivityIcon = (type) => {
    switch (type) {
      case 'photo_upload':
        return <Camera className="h-5 w-5 text-blue-500" />;
      case 'event_created':
        return <Calendar className="h-5 w-5 text-green-500" />;
      case 'user_joined':
        return <User className="h-5 w-5 text-purple-500" />;
      default:
        return <Clock className="h-5 w-5 text-gray-500" />;
    }
  };

  const getActivityColor = (type) => {
    switch (type) {
      case 'photo_upload':
        return 'bg-blue-100';
      case 'event_created':
        return 'bg-green-100';
      case 'user_joined':
        return 'bg-purple-100';
      default:
        return 'bg-gray-100';
    }
  };

  return (
    <div className="bg-white rounded-lg shadow">
      <div className="p-6">
        <div className="space-y-4">
          {activities.map((activity) => (
            <div key={activity.id} className="flex items-start space-x-3">
              <div className={`flex-shrink-0 p-2 rounded-full ${getActivityColor(activity.type)}`}>
                {getActivityIcon(activity.type)}
              </div>
              <div className="flex-1 min-w-0">
                <p className="text-sm text-gray-900">
                  {activity.message}
                </p>
                <div className="flex items-center mt-1 text-xs text-gray-500">
                  <span>{activity.user}</span>
                  <span className="mx-2">•</span>
                  <span>{activity.time}</span>
                </div>
              </div>
            </div>
          ))}
        </div>
        
        {activities.length === 0 && (
          <div className="text-center py-8">
            <Clock className="mx-auto h-12 w-12 text-gray-400" />
            <h3 className="mt-2 text-sm font-medium text-gray-900">
              No hay actividad reciente
            </h3>
            <p className="mt-1 text-sm text-gray-500">
              La actividad aparecerá aquí cuando comiences a usar la plataforma.
            </p>
          </div>
        )}
      </div>
    </div>
  );
};
